export const EDIT_CUSTOMER_ID_SELECTION = "edit-customer-id-selection"
export const CLEAR_CUSTOMER_DATA = "clear-customer-data"
export const ADD_MULTIPLE_CUSTOMER_IDS = "add-multiple-customer-ids"
export const REMOVE_MULTIPLE_CUSTOMER_IDS = "remove-multiple-customer-ids"
export const TOGGLE_OPTIONAL_ITEM = "toggle-optional-item"
export const EDIT_ITEM_QUANTITY = "edit-item-quantity"
export const EDIT_SELECTED_QUANTITY = "edit-selected-quantity"
export const SELECT_MULTIPLE_CHOICE = "select-multiple-choice"
export const UPDATE_TOTALS = "update-totals"
export const CLEAR_STATE = "clear-state"
export const SET_IGNORE_PAYMENT_STEP = "set-ignore-payment-step"
export const SET_PAYMENT_TYPE = "set-payment-type"
export const SET_PAYMENT_NOTE = "set-payment-note"
export const SET_USE_CARD_ON_FILE = "set-use-card-on-file"






// WEBPACK FOOTER //
// ./src/state/selection/selectionActionTypes.ts